import { catchError } from "../../../Actions/Error.action";

export const APPLICATION_PAGE_RECEIVE = "APPLICATION_PAGE_RECEIVE";
export const APPLICATION_PAGE_ERROR = 'APPLICATION_PAGE_ERROR';
export const APPLICATION_PRODUCTS = 'APPLICATION_PRODUCTS';


export const receive = result => ({
    type: APPLICATION_PAGE_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: APPLICATION_PAGE_ERROR,
    payload: {
        error,
    },
})

export const setProducts = (products) => ({
    type: APPLICATION_PRODUCTS,
    payload: products
});
